import { render, staticRenderFns } from "./Exit.vue?vue&type=template&id=bb8642ce&"
import script from "./Exit.vue?vue&type=script&lang=js&"
export * from "./Exit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports